import { writable } from 'svelte/store';

import languages from '$i18n/languages.json';

import { defaultLocale } from '$lib/i18n/translations';
export type language = keyof typeof languages;
function getInitialLanguage(): language {
  // 按优先级获取语言：本地存储 > 浏览器语言 > 默认语言
  return defaultLocale as language;
}
// 创建可写存储
const locale = writable<language>(getInitialLanguage());
export const setLanguage = locale.set
export default locale;